/// <amd-module name="VSS/Features/ReduxDirectory/Redux/getDirectoryProviderProps" />
import { IDirectoryContext, IDirectoryViewState } from "Contracts";
import { IModule } from "redux-dynamic-modules";
import { IDirectoryArtifact } from "VSS/Features/Directory/DirectoryContracts";
import { getDefaultState as getDefaultArtifactState } from "VSS/Features/ReduxDirectory/Redux/Artifacts/ArtifactReducer";
import { getDefaultState as getDefaultFavoriteState } from "VSS/Features/ReduxDirectory/Redux/Favorites/FavoritesReducer";
import { getDefaultState as getDefaultUIState } from "VSS/Features/ReduxDirectory/Redux/UIState/DirectoryUIStateReducer";
import { IVssPageContext } from "VSS/Platform/Context";
import { IRootProviderProps } from "VSS/Redux/Deprecated/RootProvider";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

import { DirectoryModule } from "./DirectoryModule";

export interface IDirectorySagaContext {
    pageContext: IVssPageContext;
    directoryContext: IDirectoryContext;
}

export function getDirectoryProviderProps<T extends IDirectoryArtifact>(
    directoryContext: IDirectoryContext,
    hubViewState: VssHubViewState,
    pageContext: IVssPageContext,
    telemetryArea: string,
    additionalModules: IModule<any>[] = []
): IRootProviderProps<IDirectorySagaContext, IDirectoryViewState<T>> {
    const initialState: IDirectoryViewState<T> = {
        directoryState: {
            directoryArtifactState: getDefaultArtifactState(),
            favoriteState: getDefaultFavoriteState(),
            uiState: getDefaultUIState()
        },
        hubViewState: {
            currentFilterState: {},
            currentPivot: "",
            currentViewOptions: {}
        }
    };

    const sagaContext = { directoryContext, pageContext };

    return {
        initialState: initialState as any, // Casting to any to avoid excessive stack depth type comparison build error
        sagaContext,
        scenarioName: telemetryArea,
        hubViewState,
        ttiSplitTimingName: "directoryContent",
        modules: [DirectoryModule, ...additionalModules]
    };
}
